import { render, staticRenderFns } from "./CatalogDropdownContainer.vue?vue&type=template&id=2064c29c&scoped=true&"
import script from "./CatalogDropdownContainer.vue?vue&type=script&lang=js&"
export * from "./CatalogDropdownContainer.vue?vue&type=script&lang=js&"
import style0 from "./CatalogDropdownContainer.vue?vue&type=style&index=0&id=2064c29c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2064c29c",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fcatalog-dropdown-container%2FCatalogDropdownContainer.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports